module.exports = __webpack_public_path__ + "img/AnnaDiorDiallo_140x140.fe48d0ef.jpg";